import { useQuery } from "@tanstack/react-query";

import { getBeefGrasslandFertiliser, getBeefGrasslandFertiliserAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_BEEF_GRASSLAND_FERTILISER } from "consts";

export const useGetFootprintingBeefGrasslandFertiliser = (primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;

  return useQuery({
    queryKey: [FOOTPRINTING_BEEF_GRASSLAND_FERTILISER, primaryDataId, isAdmin],
    queryFn: () => (isAdmin ? getBeefGrasslandFertiliserAdmin(primaryDataId ?? "") : getBeefGrasslandFertiliser(primaryDataId ?? "")),
    enabled: !!primaryDataId,
    gcTime: 0,
  });
};
